import { render, staticRenderFns } from "./BookDetailsWrapper.vue?vue&type=template&id=37ef73fe&scoped=true&"
import script from "./BookDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./BookDetailsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BookDetailsWrapper.vue?vue&type=style&index=0&id=37ef73fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef73fe",
  null
  
)

export default component.exports